<template>
  <div class="container">
    <h4>{{$t('home.productCase.title')}}</h4>
    <div class="slidewrap">
      <!--project carousel starts-->
      <ul class="slider" id="sliderName">
        <li class="slide"><!-- carousel item starts -->
          <div class="one-fourth">
            <div class="item-wrapp">
              <div class="portfolio-item">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'xiaoyan'})" class="item-permalink"><i class="icon-link"></i></a>
                <img src="static/img/productCase/1-img_xiaoyan_small.png" alt=""/>
              </div>
              <div class="portfolio-item-title">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'xiaoyan'})">
                  {{$t('home.productCase.tip1.title')}}
                </a>
                <p>
                  {{$t('home.productCase.tip1.subtitle')}}
                </p>
              </div>
            </div>
          </div>
          <div class="one-fourth">
            <div class="item-wrapp">
              <div class="portfolio-item">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'pad'})" class="item-permalink"><i class="icon-link"></i></a>
                <img src="static/img/productCase/2-img_pad_small.png" alt=""/>
              </div>
              <div class="portfolio-item-title">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'pad'})">
                  {{$t('home.productCase.tip2.title')}}
                </a>
                <p>
                  {{$t('home.productCase.tip2.subtitle')}}
                </p>
              </div>
            </div>
          </div>
          <div class="one-fourth">
            <div class="item-wrapp">
              <div class="portfolio-item">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'dynaudio'})" class="item-permalink"><i class="icon-link"></i></a>
                <img src="static/img/productCase/3-img_dynaudio_small.png" alt=""/>
              </div>
              <div class="portfolio-item-title">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'dynaudio'})">
                  {{$t('home.productCase.tip3.title')}}
                </a>
                <p>
                  {{$t('home.productCase.tip3.subtitle')}}
                </p>
              </div>
            </div>
          </div>
          <div class="one-fourth">
            <div class="item-wrapp">
              <div class="portfolio-item">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'Polaroid'})" class="item-permalink"><i class="icon-link"></i></a>
                <img src="static/img/productCase/4-img_Polaroid_small.png" alt=""/>
              </div>
              <div class="portfolio-item-title">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'Polaroid'})">
                  {{$t('home.productCase.tip4.title')}}
                </a>
                <p>
                  {{$t('home.productCase.tip4.subtitle')}}
                </p>
              </div>
            </div>
          </div>
        </li>
        <li class="slide"><!-- carousel item starts -->
          <div class="one-fourth">
            <div class="item-wrapp">
              <div class="portfolio-item">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'hycat'})" class="item-permalink"><i class="icon-link"></i></a>
                <img src="static/img/productCase/5-img_hycat_small.png" alt=""/>
              </div>
              <div class="portfolio-item-title">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'hycat'})">
                  {{$t('home.productCase.tip5.title')}}
                </a>
                <p>
                  {{$t('home.productCase.tip5.subtitle')}}
                </p>
              </div>
            </div>
          </div>
          <div class="one-fourth">
            <div class="item-wrapp">
              <div class="portfolio-item">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'anker'})" class="item-permalink"><i class="icon-link"></i></a>
                <img src="static/img/productCase/6-img_anker_small.png" alt=""/>
              </div>
              <div class="portfolio-item-title">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'anker'})">
                  {{$t('home.productCase.tip6.title')}}
                </a>
                <p>
                  {{$t('home.productCase.tip6.subtitle')}}
                </p>
              </div>
            </div>
          </div>
          <div class="one-fourth">
            <div class="item-wrapp">
              <div class="portfolio-item">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'shanling'})" class="item-permalink"><i class="icon-link"></i></a>
                <img src="static/img/productCase/7-img_shanling__small.png" alt=""/>
              </div>
              <div class="portfolio-item-title">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'shanling'})">
                  {{$t('home.productCase.tip7.title')}}
                </a>
                <p>
                  {{$t('home.productCase.tip7.subtitle')}}
                </p>
              </div>
            </div>
          </div>
          <div class="one-fourth">
            <div class="item-wrapp">
              <div class="portfolio-item">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'translator'})" class="item-permalink"><i class="icon-link"></i></a>
                <img src="static/img/productCase/8-img_translator_small.png" alt=""/>
              </div>
              <div class="portfolio-item-title">
                <a href="javascript:" v-on:click="$emit('change-case', {name: 'translator'})">
                  {{$t('home.productCase.tip8.title')}}
                </a>
                <p>
                  {{$t('home.productCase.tip8.subtitle')}}
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul><!-- carousel items UL ends -->
      <ul class="slidecontrols">
        <li><a href="#sliderName" class="prev">Prev</a></li>
        <li><a href="#sliderName" class="next">Next</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Case'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/Case.vue